import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FormValidatorService } from '../../../../../../shared/services/form-validator.service';
import { TitledModalWithContentService } from '../../../../../../shared/services/titled-modal-with-content.service';
import { Validators } from '../../../../../../shared/validators';
import { CustomValidators } from '../../../../../../shared/custom-validators';
import paymentOptionsConstant from '../../../../../../shared/paymentOptionsConstant';
import { AuthService } from '../../../../../../shared/services/auth.service';
import { FieldObjectModel } from '../../../../buyer';
import { ValidatorModel } from 'src/app/dashboard/admin/report/report';
import { SubmitBuyerInfoService } from '../../../../services/submit-buyer-info.service';
import { QuickCashData } from '../../../../services/quick-cash-data.service';
import { SellerNameSaverService } from '../../../../services/seller-name-saver.service';
import { ViewProductInfoHandlerService } from '../../../../services/view-product-info-handler.service';
import { FetchFieldsService } from '../../../../services/fetch-fields.service';
import { NewGateLightboxComponent } from '../../components/new-gate-lightbox/new-gate-lightbox.component';
import { LightBoxUpgComponent } from '../../components/light-box-upg/light-box-upg.component';
import { PurchaseDoneComponent } from '../../components/purchase-done/purchase-done.component';
import { GetCalculatesParamsService } from 'src/app/public-website/buyer/services/get-calculates-params.service';
import { ApplyPromoCodeService } from 'src/app/shared/services/apply-promo-code.service';
import { BuyerPaymentOptionsComponent } from '../../components/buyer-payment-options/buyer-payment-options.component';
import { LimitService } from './limit.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { CreditCardPaymentService } from 'src/app/public-website/buyer/services/creditCardPayment.service';
import { LanguageService } from '../../../../../../shared/services/language.service';
import { PayMobLightboxComponent } from '../../components/pay-mob-lightbox/pay-mob-lightbox.component';
import { ReceiptComponent } from 'src/app/public-website/public-shared/receipt/receipt.component';
import { SaveReceiptService } from 'src/app/public-website/buyer/services/save-receipt.service';
import { CardPaymentsComponent } from '../../components/card-payments/card-payments.component';
import { paymentOptionsMapping } from '../../../../services/submitBuyerHelper.service';
import { ValuLightboxComponent } from '../../components/valu-lightbox/valu-lightbox.component';
import { InstaPayOrderData, InstapayOrderPaymentComponent } from '../../components/instapay-order-payment/instapay-order-payment.component';
import { AppleVipsCalculatorService } from 'src/app/shared/product/components/apple-pay/services/apple-vips-calculator.service';
import { ApplePayService } from 'src/app/shared/product/components/apple-pay/services/apple-pay.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-buyer-info',
  templateUrl: './buyer-info.component.html',
  styleUrls: ['./buyer-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ApplePayService]
})
export class BuyerInfoComponent implements OnInit {
  rawFieldArray: any;
  buyerInfoForm!: FormGroup;
  simplifiedFieldArray: any[] = [];
  extraFillForm!: FormGroup;
  title: any;
  buttonText: any;
  code: string;
  eventFlag: boolean = true;
  eventTickets: any;
  formId!: number;
  providerObject: any;
  gateCreditCard: string = 'creditCard';
  hideSubmit: boolean = false;
  productObject: any;
  businessObject: any;
  expired: any;
  termsAccepted: boolean = true;
  termsError: boolean = false;
  paymentValidation: boolean = false;
  enableSubmit: boolean = true;
  donations = [
    { name: 'fraction', amount: 1, value: 1, selected: false },
    { name: 'five', amount: 5, value: 5, selected: false },
  ];
  @ViewChild(NewGateLightboxComponent)
  newGateLightbox!: NewGateLightboxComponent;
  @ViewChild(LightBoxUpgComponent) lightBoxUPGComponent!: LightBoxUpgComponent;
  @ViewChild(BuyerPaymentOptionsComponent)
  buyerPaymentOptionsComponent!: BuyerPaymentOptionsComponent;
  @ViewChild(PayMobLightboxComponent)
  payMobLightBoxComponent!: PayMobLightboxComponent;
  @ViewChild(CardPaymentsComponent)
  cardPaymentsComponent!: CardPaymentsComponent;
  @ViewChild(ValuLightboxComponent)
  valulightboxComponent!: ValuLightboxComponent;
  validationError!: [
    {
      field: string;
      message: string;
      validation: string;
    }
  ];
  isReceiptReady = false;
  CollectionsCustomerId = history.state.CollectionsCustomerId;
  CollectionsCustomerData: any;
  appleTrxStatus: Subscription;

  constructor(
    private fetchFieldsService: FetchFieldsService,
    public vpihs: ViewProductInfoHandlerService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public submitInfo: SubmitBuyerInfoService,
    public dialog: MatDialog,
    public modal: TitledModalWithContentService,
    private route: Router,
    private quickCashData: QuickCashData,
    public SellerNameSaver: SellerNameSaverService,
    public formValidator: FormValidatorService,
    private auth: AuthService,
    private getCalculatesParamsService: GetCalculatesParamsService,
    public applyCodeSv: ApplyPromoCodeService,
    private limitService: LimitService,
    public creditCardService: CreditCardPaymentService,
    private translate: TranslateService,
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef,
    private receiptComponent: ReceiptComponent,
    private saveReceiptService: SaveReceiptService,
    public appleVipsCalculatorService: AppleVipsCalculatorService,
    private applePayService: ApplePayService,
  ) { }

  async ngOnInit() {
    const whatsAppBtn = document.getElementById('whatsapp-chat-widget');
    if(whatsAppBtn) whatsAppBtn.style.display = 'none';

    if (
      !this.vpihs.productId &&
      !this.vpihs.paymentOptionObject.selection &&
      !this.vpihs.viewInfoObject
    ) {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }
    this.eventFlag =
      this.vpihs.viewInfoObject?.extras &&
        this.vpihs.viewInfoObject?.extras.isEvent
        ? true
        : false;
    this.eventTickets = this.eventFlag
      ? this.vpihs.viewInfoObject.extras.selectedTickets ||
      this.vpihs.viewInfoObject.extras.selectedSlots
      : null;

    try {
      this.languageService.languageUpdated.subscribe((lang: string) => {
        this.translate.use(lang);
      });
      this.vpihs.productId = this.vpihs.viewInfoObject.product.id;
      this.fetchFieldsService.setParams({
        ProductId: this.vpihs.productId,
        CollectionsCustomerId: this.CollectionsCustomerId
      });
      const result = await this.fetchFieldsService.make();
      this.formId = result.id;
      this.rawFieldArray = result.Fields;
      if (this.CollectionsCustomerId) {
        this.CollectionsCustomerData = result.CollectionsCustomerData
      }
      this.simplifiedFieldArray = this.getFieldModelArray(this.rawFieldArray, this.CollectionsCustomerData);
      this.languageService.languageUpdated.subscribe(() => {
        this.simplifiedFieldArray = this.getFieldModelArray(this.rawFieldArray, this.CollectionsCustomerData);
      });
      const formReadyArray =
        this.wrapSimlifiedArrayIntoformGroupReadySimplifiedArray(
          this.simplifiedFieldArray,
          this.eventTickets
        );
      // @ts-ignore
      this.extraFillForm = this.formValidator.createForm(formReadyArray);
    } catch (err) {
      console.log(
        '🚀 ~ file: buyer-info.component.ts ~ line 119 ~ BuyerInfoComponent ~ ngOnInit ~ err',
        err
      );
    }

    this.productObject = this.vpihs.viewInfoObject?.product;
    this.businessObject = this.productObject?.Business;
    this.expired = this.productObject?.expired || false;
    this.calculateDonation();

    this.appleVipsCalculatorService.setSetUpService(this.vpihs, this.getCalculatesParamsService);
    await this.appleVipsCalculatorService.calcVpihsForApple();
  }

  async OnDestroy(): Promise<void> {
    if (this.appleTrxStatus) this.appleTrxStatus.unsubscribe();
  }

  getFieldModelArray(fieldsArray: any, CollectionsCustomerData: any) {
    const outputArray = [];
    let constantFields = [];

    for (const field of fieldsArray) {
      const row: FieldObjectModel = {};
      row.fieldName = field.name;
      row.disabled = false;
      row.fieldValues = ''; // Initialize fieldValues to an empty string

      // Handle specific fields (Name, Email, Phone) and set fieldValues
      if (field.name === 'Name') {
        row.fieldNameAr = 'الإسم';
        if (CollectionsCustomerData?.customerBusinessName) {
          row.fieldValues = CollectionsCustomerData.customerBusinessName; // Set Name value
          row.disabled = true; // Disable the field
        }
      } else if (field.name === 'Email') {
        row.fieldNameAr = 'البريد الإلكتروني';
        if (CollectionsCustomerData?.email) {
          row.fieldValues = CollectionsCustomerData.email; // Set Email value
          row.disabled = true; // Disable the field
        }
      } else if (field.name === 'Phone') {
        row.fieldNameAr = 'رقم الهاتف';
        row.fieldType = 'phone';
        if (CollectionsCustomerData?.mobile) {
          row.fieldValues = CollectionsCustomerData.mobile; // Set Phone value
          row.disabled = true; // Disable the field
        }
      }

      // If fieldValues is still empty, set it to BuyerInfoFieldOptions
      if (!row.fieldValues || row.fieldValues.length === 0) {
        const excludedFields = ['text', 'textarea']
        if(!excludedFields.includes(field.FieldType.name)){
          row.fieldValues = field.BuyerInfoFieldOptions || []; // Default to BuyerInfoFieldOptions
        }
      }

      // Set the nameAr if available
      if (field.nameAr) {
        row.fieldNameAr = field.nameAr;
      }
      if (row.fieldName != 'Phone')
        row.fieldType =
          field.FieldType && field.FieldType.name ? field.FieldType.name : '';
      row.id = field.id;
      field.FieldValidationRules = field.FieldValidationRules || [];
      let fieldValidations = field.FieldValidationRules;
      this.translate.get('FormValidation').subscribe(() => {
        if (field.fieldRequired) {
          fieldValidations.push({
            name: 'required',
            value: null,
            message: this.translate.instant('FormValidation.Required'),
          });
        }
        if (row.fieldName == 'Email') {
          fieldValidations.push({
            name: 'email',
            value: null,
            message: this.translate.instant('FormValidation.ValidEmail'),
          });
          row.fieldType = 'email';
        } else if (row.fieldName == 'Phone') {
          row.fieldType = 'phone';
        } else if (row.fieldName == 'Name') {
          fieldValidations.push({
            name: 'pattern',
            value: /^(?!.*<[^>]+>)[\p{L}0-9 ]+$/u,
            message: this.translate.instant('FormValidation.Pattern', {
              field: 'Name',
              fieldAr: 'الإسم',
            }),
          });
          fieldValidations.push({
            name: 'minLength',
            value: 5,
            message: this.translate.instant('FormValidation.MinLength', {
              field: 'Name',
              fieldAr: 'الإسم',
              value: 5,
            }),
          });
        }
      });

      // Convert validation rules to form control validation objects
      const validationArray = [];
      for (const validation of fieldValidations) {
        if (this.getValidatorObjectFromFVObject(validation)) {
          validationArray.push(this.getValidatorObjectFromFVObject(validation));
        }
      }

      row.validations = validationArray;

      // Push to constantFields if Name, Email, or Phone, else to outputArray
      if (row.fieldName === 'Name' || row.fieldName === 'Email' || row.fieldName === 'Phone') {
        constantFields.push(row);
      } else {
        outputArray.push(row);
      }
    }

    // Return chunked arrays for the form
    return this.chunkArray([...constantFields, ...outputArray], 3);
  }

  chunkArray(myArray: any[], chunk_size: number) {
    var index = 0;
    var arrayLength = myArray.length;
    var tempArray = [];

    for (index = 0; index < arrayLength; index += chunk_size) {
      let myChunk = myArray.slice(index, index + chunk_size);
      tempArray.push(myChunk);
    }
    return tempArray;
  }

  private getValidatorObjectFromFVObject(object: any): ValidatorModel | null {
    switch (object.name) {
      case 'required':
        return {
          validatorFn: Validators.required,
          message: object.message,
        };
      case 'email':
        return {
          validatorFn: Validators.email,
          message: object.message,
        };
      case 'futureDate':
        return {
          validatorFn: CustomValidators.dateInTheFuture,
          message: object.message,
        };
      case 'pattern':
        return {
          validatorFn: CustomValidators.customPattern(new RegExp(object.value)),
          message: object.message,
        };
      case 'minLength':
        return {
          validatorFn: Validators.minLength(object.value),
          message: object.message,
        };
      case 'min':
        return {
          validatorFn: Validators.min(object.value),
          message: object.message,
        };
      case 'requiredNumber':
        return {
          validatorFn: CustomValidators.requiredNumber,
          message: object.message,
        };
      default:
        return null;
    }
  }

  wrapSimlifiedArrayIntoformGroupReadySimplifiedArray(
    simplifiedFieldArray: Array<any>,
    eventTickets: any
  ) {
    const outputArray = [];
    if (!eventTickets) {
      for (let chunk of simplifiedFieldArray) {
        for (const fieldData of chunk) {
          const outputField: FormFieldModel = {
            fieldName: fieldData.fieldName,
            fieldNameAr: fieldData.fieldNameAr,
            defaultValue: fieldData.fields || null,
            validators: fieldData.validations || [],
            array: fieldData.fields ? true : false,
          };
          outputArray.push(outputField);
        }
      }
      return outputArray;
    }
    for (const ticket of eventTickets) {
      let quantity = ticket.ticketQuantity || ticket.slotQuantity;
      for (let i = 1; i <= quantity; i++) {
        const outputArrayField: any = {
          fieldName: (ticket.ticketName || ticket.slotId) + i,
          defaultValue: this.generateNewFieldArrayObject(simplifiedFieldArray),
          validators: null,
          array: true,
        };
        outputArray.push(outputArrayField);
      }
    }
    return outputArray;
  }

  generateNewFieldArrayObject(incoming: Array<any>) {
    const outputArray = [];
    for (let chunk of incoming) {
      for (const fieldData of chunk) {
        const outputField: FormFieldModel = {
          fieldName: fieldData.fieldName,
          defaultValue: fieldData.fields || null,
          validators: fieldData.validations || [],
          array: fieldData.fields ? true : false,
        };
        outputArray.push(outputField);
      }
    }
    return outputArray;
  }

  copyFromMain(name: string) {
    const allTickets = Object.keys(this.extraFillForm.controls);
    const theFirstValues = this.extraFillForm.value[allTickets[0]];
    allTickets.shift();
    for (const ticket of allTickets) {
      if (name == ticket) {
        for (const key of Object.keys(theFirstValues)) {
          // @ts-ignore
          this.extraFillForm.controls[ticket].controls[key].setValue(
            theFirstValues[key]
          );
        }
      }
    }
  }

  getEventQuantityArray(eventQuantity: number) {
    const eventQuantityArray = [];
    for (let i = 0; i < eventQuantity; i++) {
      eventQuantityArray.push(i);
    }
    return eventQuantityArray;
  }

  // open quick cash dialog function
  openDialog(done: any): void {
    if (!done) {
      this.modal.open({
        title: 'Quick Cash Error',
        content: 'Something Went Wrong, please try again later',
        closeButtonName: 'exit',
      });
    }

    if (done) {
      this.quickCashData.data = this.providerObject;
      this.quickCashData.data.provider = done.provider;
      this.quickCashData.data.sellerName = done.sellerName;
      if (done.provider == 'Fawry') {
        this.route.navigate(['fawry/success']);
      } else {
        this.route.navigate(['cash/success']);
      }
    }
  }

  async applyPromoCode() {
    if (this.code && this.code.length > 0) {
      try {
        const codeValue = this.code;
        this.getCalculatesParamsService.setCodeName(codeValue);
        await this.getCalculatesParamsService.calculateInfos();
        this.applyCodeSv.setParams({
          codeName: codeValue,
          ProductId: this.vpihs.productId,
          BusinessId: this.vpihs.BusinessId,
          paymentOption: this.vpihs.paymentOptionObject.selection,
        });

        const result = await this.applyCodeSv.make();
        if (this.eventTickets) {
          let ticketQty = 0;
          for (let ticket of this.eventTickets) {
            ticketQty += Number(ticket.ticketQuantity);
          }
          if (result.redeemedTicketQuantity + ticketQty > result.ticketQuantity)
            throw new Error('insufficient promo code quantity');
        }
        this.vpihs.PromocodeId = result.id;
        this.formValidator.formErrors.code = '';
        this.appleVipsCalculatorService.setPromoCode(result, this.vpihs.discount);
        this.vpihs.hasFreePromoCode = false;
        if (
          (result.precentage == 100 && result.type == 'percentage') ||
          (result.type == 'flat' && this.vpihs.total == 0)
        ) {
          this.buyerPaymentOptionsComponent.options = [];
          this.buyerPaymentOptionsComponent.selection = null;
          this.vpihs.paymentOptionObject.selection = null;
          this.vpihs.hasFreePromoCode = true;
        }
      } catch (err) {
        this.vpihs.PromocodeId = null;
        this.formValidator.formErrors.code =
          err.faultyRequest?.error?.message || err.message;
        this.vpihs.applyPromoCode(0);
        this.appleVipsCalculatorService.disablePromoCode();
        this.vpihs.hasFreePromoCode = false;
      }
    }
  }

  validateBuyerInputs(){
    if (!this.enableSubmit) return false;
    try{
      Object.keys(this.extraFillForm.controls).forEach((key) => {
        const control = this.extraFillForm.get(key);
        if (control?.disabled) {
          control.enable();
        }
      });

      const selectedPaymentOption = this.vpihs.paymentOptionObject.selection;
      if (
        !this.termsAccepted ||
        !this.extraFillForm.valid ||
        !selectedPaymentOption
      ){
        if (this.extraFillForm.invalid) {
          this.extraFillForm.markAsDirty();
          this.extraFillForm.markAllAsTouched();
          const extraFill = document.getElementById('extraFill');
          extraFill?.scrollIntoView({ behavior: 'smooth' });
        }

        if (!this.termsAccepted) {
          this.termsError = true;
        }

        if(!selectedPaymentOption  && this.vpihs.hasFreePromoCode) return true;

        if (!selectedPaymentOption) {
          this.paymentValidation = true;
          if (this.extraFillForm.valid) {
            const paymentOptionsRadio = document.getElementById('paymentOptions');
            paymentOptionsRadio?.scrollIntoView({ behavior: 'smooth' });
          }
        }


        throw new Error("Inputs validation, all data must filled,")
      }



      return true;
    }catch(e){
      console.log("Input Validation error, ", e)
      return false;
    }
  }

  async submitWrapper(){
    if(!this.validateBuyerInputs()) return;
    this.enableSubmit = false;

    if(this.vpihs.paymentOptionObject.selection  == this.appleVipsCalculatorService.applePayName){

      this.appleTrxStatus = this.applePayService
        .pay(this.submit.bind(this))
        ?.subscribe((data) => {
          this.router.navigate(['gate'], {
            queryParams: {
              refNum: data.trxRefNum,
            },
          });
        });

      this.enableSubmit = true;
    } else {
      await this.submit();
    }
  }

  async submit() {
    this.clearLocalStorage();
    this.vpihs.donation = this.getDonationvalue();

      if (
        paymentOptionsMapping[this.vpihs.paymentOptionObject.selection] !==
        this.gateCreditCard
      ) {
        this.hideSubmit = true;
      }
      const buyers = [];
      if (this.eventFlag) {
        const formObject = this.extraFillForm.value;
        for (const ticketvalueKey of Object.keys(formObject)) {
          buyers.push(formObject[ticketvalueKey]);
        }
      } else {
        buyers.push(this.extraFillForm.value);
      }

      let promo: any = {};
      if (this.vpihs.PromocodeId) {
        promo = {
          id: this.vpihs.PromocodeId,
        };
      }
      const submitObject: any = {
        ProductId: this.vpihs.productId,
        Buyers: buyers,
        PackageId: this.vpihs.packageId,
        vpihs: this.vpihs.getSubmitObject(),
        promoCode: promo,
        donationAmount: this.vpihs.donation,
      };
      if (
        this.vpihs.viewInfoObject.extras &&
        this.vpihs.viewInfoObject.extras.selectedTickets
      ) {
        const outputTickets = [];
        for (const ticket of this.vpihs.viewInfoObject.extras.selectedTickets) {
          const newTicket = {
            itemId: ticket.ticketId,
            description: ticket.ticketName,
            price: Number(ticket.ticketPrice),
            quantity: Number(ticket.ticketQuantity),
          };
          outputTickets.push(newTicket);
        }
        submitObject.vpihs['tickets'] = outputTickets;
      } else if (
        this.vpihs.viewInfoObject.extras &&
        this.vpihs.viewInfoObject.extras.selectedSlots
      ) {
        const outputSlots = [];
        for (const slot of this.vpihs.viewInfoObject.extras.selectedSlots) {
          const newSlot = {
            itemId: slot.slotId,
            description: slot.slotName,
            price: Number(slot.slotPrice),
            quantity: Number(slot.slotQuantity),
          };
          outputSlots.push(newSlot);
        }
        submitObject.vpihs['slots'] = outputSlots;
      }

      if (
        this.vpihs.viewInfoObject.extras &&
        this.vpihs.viewInfoObject.extras.isCustomPayment
      ) {
        submitObject['isCustomPayment'] = true;
        submitObject['businessId'] = this.vpihs.viewInfoObject.business.id;
      }

      const paymentOption =
        paymentOptionsMapping[this.vpihs.paymentOptionObject.selection];
      if (paymentOption == this.gateCreditCard) {
        this.setLocalStorageItems();
        this.limitService.setParams({
          businessId: this.businessObject.id,
          limitType: 'creditCard',
          trxAmount: this.vpihs.getSubmitObject().total,
        });
        let result: { limitExceeded: boolean; singleLimitExceeded: boolean } =
          await this.limitService.make();
        if (result.singleLimitExceeded) {
          this.showErrorMessage('Credit Card');
          return;
        }
      } else if (paymentOption == 'Qassatly') {
        this.limitService.setParams({
          businessId: this.businessObject.id,
          limitType: 'qassatly',
          trxAmount: this.vpihs.getSubmitObject().total,
        });
        let result: { limitExceeded: boolean; singleLimitExceeded: boolean } =
          await this.limitService.make();
        if (result.limitExceeded) {
          this.showErrorMessage('Qassatly monthly');
          return;
        }
        if (result.singleLimitExceeded) {
          this.showErrorMessage('single');
          return;
        }
      }

      if (
        this.vpihs.viewInfoObject.extras &&
        this.vpihs.viewInfoObject.extras.isCustomPayment
      ) {
        submitObject['isCustomPayment'] = true;
        submitObject['businessId'] = this.vpihs.viewInfoObject.business.id;
      }
      if (paymentOption == 'Contact') {
        const { value: clientId } = await Swal.fire<number>({
          title: 'Please Enter your national number',
          input: 'number',
          showCancelButton: true,
          inputValidator: (value) => {
            if (!value) {
              return 'You need to write something!';
            }
            if (value.length !== 14) {
              return 'National number must be 14 number';
            }
            return "";
          },
        });
        if (!clientId) {
          this.enableSubmit = true;
          return;
        }
        submitObject['clientId'] = clientId;
      }
      const receiptName = +new Date() + '.receipt';
      submitObject['receiptName'] = receiptName;
      submitObject['source'] = this.getCalculatesParamsService.trackData(this.vpihs.productId);
      this.submitInfo.setParams(submitObject);
      try {
        this.isReceiptReady = true;
        this.cdr.detectChanges();
        await this.getCalculatesParamsService.calculateInfos();
        this.saveReceiptService.setParams({
          html: await this.receiptComponent.getReceiptBodyForAttachment(),
          receiptName,
        });
        // await this.saveReceiptService.make();
        const submitBuyerInfo = await this.submitInfo.make();
        this.enableSubmit = true;
        this.vpihs.date = new Date();
        this.vpihs.refNum = submitBuyerInfo.refNum;
        if (submitBuyerInfo.error) {
          if (submitBuyerInfo.isPromoCodeInvalid) {
            await this.applyPromoCode();
          }
        } else {
          if (this.vpihs.total == 0 && this.vpihs.PromocodeId && submitBuyerInfo.PaymentAttempt.status == 'PAID') {
            // take this lines
            this.router.navigate(['gate'], {
              queryParams: {
                refNum: submitBuyerInfo.PaymentAttempt.providerRefNum,
              },
            });
            return
          }

          if (submitBuyerInfo.isQuantityInvalid) {
            this.modal.open({
              title:
                "Sorry, the quantity you've chosen has just run out. Please return to the product page to see the remaining quantity.",
              content: 'Please try again',
              closeButtonName: 'exit',
            });
          }

          this.providerObject = submitBuyerInfo['Provider'];
          const paymentOption =
            paymentOptionsMapping[this.vpihs.paymentOptionObject.selection];
          const isInstallments =
            paymentOption == this.gateCreditCard ||
            paymentOption.includes('NBE') ||
            paymentOption.includes('BM');
          const isCreditCard =
            isInstallments ||
            paymentOption === 'Card_Payments' ||
            paymentOption ===
            paymentOptionsConstant.constantPaymentOptions.name.MEEZA;
          if (isCreditCard && submitBuyerInfo) {
            this.creditCardService.providerObject = submitBuyerInfo['Provider'];
            this.router.navigate(['credit-card'], {
              relativeTo: this.activatedRoute,
            });
          }

          if(paymentOption === paymentOptionsConstant.constantPaymentOptions.name.APPLE_PAY){
            this.creditCardService.providerObject = submitBuyerInfo['Provider'];
            return;
          }

          if (paymentOption === 'Mobile_Wallet' || paymentOption == 'PaySky') {
            this.lightBoxUPGComponent.tID = this.providerObject['terminalID'];
            this.lightBoxUPGComponent.secureHash =
              this.providerObject['secureHash'];
            this.lightBoxUPGComponent.paymentMethodFromLightBox =
              this.providerObject['paymentMethodFromLightBox'];
            this.lightBoxUPGComponent.orderId = this.providerObject['voucher'];
            this.lightBoxUPGComponent.mID = this.providerObject['merchantID'];
            this.lightBoxUPGComponent.amount =
              paymentOption == 'PaySky'
                ? this.providerObject['amount']
                : this.providerObject['amount'] * 100;
            this.lightBoxUPGComponent.trxDateTime = this.providerObject['date'];
            this.lightBoxUPGComponent.MerchantReference =
              submitBuyerInfo['PaymentAttempt']['providerRefNum'];
            this.lightBoxUPGComponent.qrcode =
              submitBuyerInfo['Provider']['qrcode'];
            this.lightBoxUPGComponent.SystemReference =
              submitBuyerInfo['Provider']['systemReference'];
            paymentOption == 'PaySky'
              ? this.lightBoxUPGComponent.openPaySky()
              : this.lightBoxUPGComponent.callLightBox();
          }

          if (paymentOption == 'Qassatly') {
            localStorage.setItem('code', this.SellerNameSaver.pattern);
            window.location.href = submitBuyerInfo.Provider.redirectUrl;
          }
          if (paymentOption == 'ValU' || paymentOption == 'Souhoola' || paymentOption == 'Halan') {
            this.setLocalStorageItems();
            this.valulightboxComponent.initiatLightBox(
              this.providerObject.redirectUrl,
              submitBuyerInfo.PaymentAttempt.providerRefNum
            );
          }
          if (paymentOption === 'Cash' || paymentOption === 'Fawry') {

            this.setLocalStorageItems();
            const provider = paymentOption == 'Cash' ? 'Aman' : 'Fawry';
            this.openDialog({
              ...submitBuyerInfo['done'],
              sellerName: this.vpihs.viewInfoObject.product?.Business?.name,
              provider,
            });
          }
          if (
            paymentOption !== 'Aman Installments' &&
            paymentOption.includes('Installments')
          ) {
            this.setLocalStorageItems();
            this.payMobLightBoxComponent.initiatLightBox(
              this.providerObject['lightboxURL']
            );
          }
          if (paymentOption === 'Contact') {
            this.router.navigate([window.location.pathname + '/contact-options']);
            localStorage.setItem('contactData',JSON.stringify(submitBuyerInfo));
          }
          if (paymentOption === 'Mogo') {
            this.router.navigate([window.location.pathname + '/mogo-options']);
            localStorage.setItem('mogoData', JSON.stringify(submitBuyerInfo.Provider));
          }

          if (paymentOption === 'Tru') {
            this.router.navigate([window.location.pathname + '/tru-pay']);
            localStorage.setItem(
              'truData',
              JSON.stringify({
                totalAmount: this.vpihs.total,
                productId: this.vpihs.productId,
                productName: this.vpihs.viewInfoObject.product.productName,
                paymentAttemptId: submitBuyerInfo.PaymentAttempt.id,
                businessName: this.businessObject.name,
              })
            );
          }

          if (paymentOption === 'Offline Payment') {
            this.router.navigate(['seller/dashboard']);
          }
          if (paymentOption === 'Aman Installments') {
            this.router.navigate([window.location.pathname + '/aman-options']);
            localStorage.setItem('amanData', JSON.stringify(submitBuyerInfo.Provider));
          }
          if (paymentOption === 'InstaPay') {
            this.openInstapayDialog(submitBuyerInfo.Provider);
          }


          if (paymentOption == null || paymentOption == undefined) {
            this.dialog.open(PurchaseDoneComponent, {
              data: {
                refNumber: submitBuyerInfo.PaymentAttempt.providerRefNum,
              },
            });
            this.router.navigate(['/']);
          }
        }
      } catch (err) {
        this.enableSubmit = true
        console.log('error', err);
        Swal.fire({
          icon: 'error',
          title: 'Ooops!',
          text: err.faultyRequest?.error.message,
        });
      }


    return null
  }
  setLocalStorageItems(): void {

    localStorage.setItem('vpihs', JSON.stringify(this.vpihs.getSubmitObject({amount: {showForgenValues: true}})));
    localStorage.setItem(
      'code',
      JSON.stringify(this.vpihs.viewInfoObject.product.code)
    );
    localStorage.setItem(
      'viewInfoObject',
      JSON.stringify(this.vpihs.viewInfoObject)
    );
  }
  replaceErrors(value: any) {
    if (value instanceof Error) {
      var error: any = {};
      Object.getOwnPropertyNames(value).forEach((key: string) => {
        error[key] = value;
      });
      return error;
    }
    return value;
  }

  async ifSeller() {
    const businessData = await this.auth.getBusiness();
    let productsBusinessID;
    let businessID;
    if (this.productObject && this.businessObject) {
      productsBusinessID = this.businessObject.id;
    }

    if (businessData) {
      businessID = businessData.id;
    }

    return productsBusinessID === businessID;
  }

  acceptTerms() {
    if (this.termsAccepted == false) {
      this.termsAccepted = true;
      this.termsError = false;
    } else {
      this.termsAccepted = false;
      this.termsError = true;
    }
  }

  showErrorMessage(limitType: string): void {
    Swal.fire({
      icon: 'error',
      title: 'Ooops!',
      text: `Seller ${limitType} limit has been reached, please
            contact seller or use another payment option`,
    });
  }

  updateNbeInstallmentsOptions(value: string[]): void {
    this.vpihs.installmentValues = value;
  }
  handleBuyerOptionclickEvent() {
    this.calculateDonation();
  }
  calculateDonation(): void {
    let total = this.vpihs.total;
    this.donations[1].amount = 5 - (total % 5);
  }
  setDonation(donationType: string): void {
    this.donations.forEach((element) => {
      if (element.name == donationType) element.selected = true;
      else element.selected = false;
    });
  }
  getDonationvalue(): number {
    let value = 0;
    this.donations.forEach((element) => {
      if (element.selected) {
        value = element.amount;
        return;
      }
    });
    return value;
  }

  clearLocalStorage() {
    localStorage.removeItem('vpihs');
    localStorage.removeItem('viewInfoObject');
  }

  getEventTicket(eventTicket: any, index: number) {
    return (eventTicket['ticketName'] || eventTicket['slotId']) + (index + 1);
  }

  openInstapayDialog(providerData?: InstaPayOrderData) {
    this.dialog.open(InstapayOrderPaymentComponent, {
      data: providerData,
      disableClose: true,
      panelClass: "round-dialog"
    });
  }
}

export interface FormFieldModel {
  fieldName: string;
  fieldNameAr?: string;
  defaultValue: any | string | FormFieldModel;
  validators?: Array<ValidatorModel>;
  array?: boolean;
}


